import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import sweetAlert from 'sweetalert'
import milestone from '../../assets/images/Milestone_Icon.png'


export class Datatable_product extends Component {
    constructor(props) {
        super(props)
        this.state = {
            checkedValues: [],
            myData: this.props.myData
        }
    }

    selectRow = (e, i) => {
        if (!e.target.checked) {
            this.setState({
                checkedValues: this.props.checkedValues.filter((item, j) => i !== item)
            });
        } else {
            this.props.checkedValues.push(i);
            this.setState({
                checkedValues: this.props.checkedValues
            })
        }
    }

    handleRemoveRow = () => {
        const selectedValues = this.props.checkedValues;
        const updatedData = this.props.myData.filter(function (el) {
            return selectedValues.indexOf(el.id) < 0;
        });
        this.setState({
            myData: updatedData
        })
        toast.success("Successfully Deleted !")
    };

    // renderEditable = (cellInfo) => {
    //     return (
    //         <div
    //             style={{ backgroundColor: "#fafafa" }}
    //             contentEditable
    //             suppressContentEditableWarning
    //             onBlur={e => {
    //                 const data = [...this.props.myData];
    //                 data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
    //                 this.setState({ myData: data });
    //             }}
    //             dangerouslySetInnerHTML={{
    //                 __html: this.props.myData[cellInfo.index][cellInfo.column.id]
    //             }}
    //         />
    //     );
    // }

    Capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    deleteHandler = (id) => {
        const url = `${process.env['REACT_APP_HOST']}/api/products/${id}`;
        const params = {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            }
        };
        fetch(url, params)
            .then(response => response.json())
            .then(data => {
            })
    }

    render() {
        const { pageSize, myClass, multiSelectOption, pagination } = this.props;
        const { myData } = this.props
        console.log("myData")
        console.log(myData)
        const columns = [];
        for (var key in myData[0]) {

            let editable = this.renderEditable

            if (key === "name") {
                editable = null;
            }

            if (key === "price") {
                editable = null;
            }
            if (key === "image") {
                editable = null;
            }
            if (key === "description") {
                editable = null;
            }
            if (key === "shortDescription") {
                editable = null;
            }
            if (key === "category") {
                editable = null;
            }
            if (key === "gameVersion") {
                editable = null;
            }
            if (key === "createdAt") {
                editable = null;
            }
            if (key === "numReviews") {
                editable = null;
            }
            if (key === "rating") {
                editable = null;
            }

            if (['name'].includes(key)) {
                columns.push(
                    {
                        Header: <b>{this.Capitalize(key.toString())}</b>,
                        accessor: key,
                        Cell: editable,
                        style: {
                            textAlign: 'center'
                        }
                    });
            }
            if (["gameVersion"].includes(key)) {
                columns.push(
                    {
                        Header: <b>Game Version</b>,
                        accessor: key,
                        Cell: editable,
                        style: {
                            textAlign: 'center',                           
                        }
                    });
            }


        }

        if (multiSelectOption == true) {
            columns.push(
                {
                    Header: <button className="btn btn-danger btn-sm btn-delete mb-0 b-r-4"
                        onClick={
                            (e) => {
                                if (window.confirm('Are you sure you wish to delete this item?'))
                                    this.handleRemoveRow()
                            }}>Delete</button>,
                    id: 'delete',
                    accessor: str => "delete",
                    sortable: false,
                    style: {
                        textAlign: 'center'
                    },
                    Cell: (row) => (
                        <div>
                            <span >
                                <input type="checkbox" name={row.original.id} defaultChecked={this.props.checkedValues.includes(row.original.id)}
                                    onChange={e => this.selectRow(e, row.original.id)} />
                            </span>
                        </div>
                    ),
                    accessor: key,
                    style: {
                        textAlign: 'center'
                    }
                }
            )
        } else {

            columns.push(
                {
                    Header: <b>Id</b>,
                    id: 'info',
                    accessor: str => "info",
                    Cell: (row) => (
                        <>
                            <textarea className="form-control" value={row.original.id} />
                        </>
                    ),
                    style: {
                        textAlign: 'center'
                    },
                    sortable: false
                }
            )
            columns.push(
                {
                    Header: <b>Is Game Uploaded</b>,
                    id: 'info',
                    accessor: str => "info",
                    Cell: (row) => (
                        <>
                            {row.original.game == 1 ?
                                <div class=" btn-success btn-sm">Game Uploaded</div>
                                :
                                <div class=" btn-danger btn-sm">Game Unavailable</div>
                            }

                        </>
                    ),
                    style: {
                        textAlign: 'center'
                    },
                    sortable: false
                }
            )
            columns.push(
                {
                    Header: <b>Status</b>,
                    id: 'info',
                    accessor: str => "info",
                    Cell: (row) => (
                        <>
                            {row.original.status == 1 ?
                                <div class=" btn-success btn-sm">Active</div>
                                :
                                <div class=" btn-danger btn-sm">Disabled</div>
                            }

                        </>
                    ),
                    style: {
                        textAlign: 'center'
                    },
                    sortable: false
                }
            )

            columns.push(
                {
                    Header: <b>Action</b>,
                    id: 'delete',
                    accessor: str => "delete",
                    Cell: (row) => (
                        <div>
                            <span onClick={() => {
                                // if (window.confirm('Are you sure you wish to delete this item?')) {
                                //     let data = myData;
                                //     data.splice(row.index, 1);
                                //     this.setState({ myData: data });
                                //     this.deleteHandler(row.original.id);
                                //     toast.success("Successfully Deleted !")
                                // }

                                sweetAlert({ title: "Are you sure you wish to delete this item?", icon: "warning", dangerMode: true, buttons: true })
                                    .then((value) => {
                                        if (value) {
                                            let data = myData;
                                            data.splice(row.index, 1);
                                            this.setState({ myData: data });
                                            this.deleteHandler(row.original.id);
                                            toast.success("Successfully Deleted !")
                                        }
                                    })
                            }}> 
                                <i className="fa fa-trash" style={{ width: 35, fontSize: 20, padding: 11, color: '#e4566e' }}
                                ></i>
                            </span>

                            {/* <a href={`${process.env.PUBLIC_URL}/reports/invoiceReport`}><i className="fa fa-pencil" style={{ width: 35, fontSize: 20, padding: 11,color:'rgb(40, 167, 69)' }}></i></a>
                    */}
                            <a href={`${process.env.PUBLIC_URL}/products/digital/edit-product/${row.original.id}`}>
                                <i className="fa fa-edit" style={{ width: 35, fontSize: 20, padding: 11, color: 'rgb(40, 167, 69)' }}></i>
                            </a>
                            <a href={`${process.env.PUBLIC_URL}/mcqMaster/${row.original.id}`}>
                                <i className="fa fa-list" style={{ width: 35, fontSize: 20, padding: 11, color: 'rgb(222 117 6)' }}></i>
                            </a>
                            <a href={`${process.env.PUBLIC_URL}/mlilestone/${row.original.id}`}>
                                {/* <i className="fa fa-blind" style={{ width: 35, fontSize: 20, padding: 11, color: 'rgb(55 40 167)' }}></i> */}
                                <img src={milestone} style={{ width: 30, marginTop:-10,marginLeft:4 , padding: 5, color: 'rgb(55 40 167)' }} alt="" />
                            </a>
                            <a href={`${process.env.PUBLIC_URL}/add-zip-courses/${row.original.id}`}>
                                <i className="fa fa-wrench" style={{ width: 35, fontSize: 20, padding: 11, color: 'rgb(40, 167, 69)' }}></i>
                            </a>
                        </div>
                    ),
                    style: {
                        textAlign: 'center'
                    },
                    sortable: false
                }
            )
        }

        return (
            <Fragment>
                <ReactTable
                    data={myData}
                    columns={columns}
                    defaultPageSize={pageSize}
                    className={myClass}
                    showPagination={pagination}
                />
                <ToastContainer />
            </Fragment>
        )
    }
}

export default Datatable_product
